import { graphql } from './graphql'
import { type SanitizedResult } from '@amzn/bf-gql'
export const trackLikesContextFrag = graphql(`
    fragment trackLikesContext on Track @_unmask {
        __typename
        id
        likesContext @include(if: $isAuthenticated) {
            liked
            state
        }
    }
`)

export type TrackLikesContext = SanitizedResult<typeof trackLikesContextFrag>
